import { render, staticRenderFns } from "./GeneralProducts.vue?vue&type=template&id=74c29e8e"
import script from "./GeneralProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneralProducts.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports